import React, { ReactNode } from 'react';
import { Flexer } from '../elements/LayoutElements';

const Background = () => {
    const style = {
        position: 'absolute' as const,
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '100%',
        height: '12rem',
    };
    return <svg style={style}>
        <defs>
            <pattern id="spots" width={16} height={16} patternUnits="userSpaceOnUse">
                <g transform={`translate(${16 / 2}, ${16 / 2})`}>
                    <circle cx={0.5} cy={0.5} r="3" fill="#627496" />
                </g>
            </pattern>

            <linearGradient id="fade" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="white" stopOpacity="0" />
                <stop offset="50%" stopColor="white" stopOpacity=".5" />
                <stop offset="100%" stopColor="white" stopOpacity="0" />
            </linearGradient>

            <mask id="fadeMask">
                <rect width="100%" height="100%" fill="url(#fade)" />
            </mask>
        </defs>

        <rect width="100%" height="100%" fill="url(#spots)" mask="url(#fadeMask)" />
    </svg>;
};

export const SpotlightStrip = ({ children }: { children: ReactNode }) => {
    return <Flexer relative>
        <Background />
        {children}
    </Flexer>;
};
